module.exports = __webpack_public_path__ + "static/media/national_day_cat_icon.61b40c8f.png";